export default {
  heading: {
    widgetName: "Shopping Product Widget",
    widgetID: "107",
    cardCount: "5",
    headlineType: "h2",
    widgetWidth: '3',
    layoutName: "lob_widget",
    headline: "SHOP Favourites",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `shop | SHOP Favourites`,
      eventLabelCardClick: `shop | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `shop | headline | {{headline}}`,
      eventLabelView: `shop | SHOP Favourites`,
    },
  },

	data: [{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: 'THB960',
			formattedPriceWeb: 'THB960',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_1-Mt-Sapola.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Aroma Oil Set',
			title: 'Mt.Sapola',
			url: 'https://www.airasia.com/shop/th/en/product/mt-sapola-inflight-harikul-group-co-ltd/paper-box-with-4x65ml-massage-oils?type_id=2'
		},
		{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: 'THB590',
			formattedOriginalPriceWeb: 'THB590',
			formattedPriceMob: 'THB390',
			formattedPriceWeb: 'THB390',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_2-vitanatureplus.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Biotin Zinc with Horsetail Extract 30 Capsules',
			title: 'Vitanatureplus+',
			url: 'https://www.airasia.com/shop/th/en/product/rs-livewell-co-ltd-inflight/vitanature-biotin-zinc-with-horsetail-extract-30-capsules?type_id=2'
		},
		{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: 'THB420',
			formattedPriceWeb: 'THB420',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_3-Maithong.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Mini Natural Soap Collection',
			title: 'Maithong',
			url: 'https://www.airasia.com/shop/th/en/product/maithong-inflight-p-and-t-siam-co-ltd/maithong-mini-natural-soap-collection-green-box?type_id=2'
		},
		{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: 'THB120',
			formattedPriceWeb: 'THB120',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_4-PHUTAWAN.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Virgin Coconut Oil 100 ml',
			title: 'PHUTAWAN',
			url: 'https://www.airasia.com/shop/th/en/product/phutawan-herb-and-cosmetic-co-ltd-inflight/virgin-coconut-oil-100-ml?type_id=2'
		},
		{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: 'THB600',
			formattedOriginalPriceWeb: 'THB600',
			formattedPriceMob: 'THB390',
			formattedPriceWeb: 'THB390',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_5-REJU.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Real Bird&rsquo;s Nest Beverage Classic Formula 45 ml x 6 Bottles',
			title: 'REJU',
			url: 'https://www.airasia.com/shop/th/en/product/rs-livewell-co-ltd-inflight/reju-real-birds-nest-beverage-classic-formula-45-ml-x-6-bottles?type_id=2'
		},
		{
			cta: 'Add To Cart',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: 'THB190',
			formattedPriceWeb: 'THB190',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_6-ChaobanMarket.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Premium Elephant Printed Pants Free Size (Red)',
			title: 'Chaoban Market',
			url: 'https://www.airasia.com/shop/th/en/product/use-network-company-limited-inflight/premium-quality-elephant-printed-pants-free-size-red?type_id=2'
		}
	]
}